import(/* webpackMode: "eager", webpackExports: ["CallDealer"] */ "/app/apps/web/src/Components/CallDealer/CallDealer.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/Components/Newsletter/audi_visu_q5_famille_2000x1030 1.png");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/Components/Newsletter/audi_visu_q5_famille_2000x1030_1_1.webp");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/Components/Newsletter/EmailInputForm/EmailInputForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientTasks"] */ "/app/apps/web/src/Components/Reviews/ClientTasks/ClientTasks.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/Components/Reviews/ReviewBody/ReviewBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/Components/Reviews/ReviewHero/StickyCta/StickyCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageCarouselWrapper"] */ "/app/apps/web/src/Components/Reviews/ReviewImageCarousel/ImageCarouselWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/ads/src/Components/Ad/Ad.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/ads/src/Components/AdSidebar/AdSidebar.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignBlock"] */ "/app/libs/campaign-promo/src/CampaignBlock/CampaignBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/libs/gds/src/Breadcrumbs/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/Grid/Components/Col.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/Grid/Components/Container.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/Grid/Components/Row.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/ReviewRating/ReviewRating.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/ReviewTile/Styles/Default.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/page-builder/src/Components/FullWidth/FullWidth.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/page-builder/src/Components/ReviewCards/ReviewCards.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/page-builder/src/Components/RichText/RichText.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/pdp/src/Components/ProsAndCons/ProsAndCons.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/Components/Newsletter/Newsletter.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/page-builder/src/Components/VehicleCarousel/VehicleCarousel.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/Badge/Styles/Default.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/Badge/Styles/Variant.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/ReducedPrice/ReducedPrice.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/TotalPrice/TotalPrice.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/gds/src/Pill/Styles/Pill.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/Components/Reviews/ReviewHero/ReviewHero.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/(internal)/(web)/reviews/[make]/[model]/Page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CompareCheckbox"] */ "/app/libs/shared-components/src/Compare/CompareCheckbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavouritesButton"] */ "/app/libs/shared-components/src/FavouritesButton/FavouritesButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared-components/src/GuaranteeTag/GuaranteeTag.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["KenticoImage"] */ "/app/libs/shared-components/src/KenticoImage/KenticoImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared-components/src/LegalText/LegalText.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/Components/Reviews/ReviewHeader/ReviewHeader.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToFinance"] */ "/app/libs/shared-components/src/ScrollToFinance/ScrollToFinance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackPage"] */ "/app/libs/tracking/src/Components/ClientWrappers/TrackPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/vehicle-tile/src/Components/Badges/Badges.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/page-builder/src/Components/Author/Author.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/shared-components/src/ImageCarousel/ImageCarousel.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/(internal)/(web)/reviews/Components/ReviewAds.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/vehicle-tile/src/Components/ExpandableFinance/ExpandableFinance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroImage"] */ "/app/libs/vehicle-tile/src/Components/HeroImage/HeroImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/vehicle-tile/src/Components/PriceRatingGauge/PriceRatingGauge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipFinance"] */ "/app/libs/vehicle-tile/src/Components/TooltipFinance/TooltipFinance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/vehicle-tile/src/Components/VehicleLabels/VehicleSpecLabels/DynamicVehicleSpec.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/vehicle-tile/src/Components/VehicleLabels/VehicleSpecLabels/VehicleSpecLabels.module.css");
;
import(/* webpackMode: "eager" */ "/app/libs/vehicle-tile/src/VehicleTile/VehicleTile.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["VehicleTileAnchor"] */ "/app/libs/vehicle-tile/src/VehicleTile/VehicleTileAnchor.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next-runtime-env@3.3.0_next@15.5.1-canary.23_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@pla_7czfizjtzbvfg3lhrcjfv5ewsy/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next-runtime-env@3.3.0_next@15.5.1-canary.23_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@pla_7czfizjtzbvfg3lhrcjfv5ewsy/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.1-canary.23_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_bab_ghquls7ng4vr2wvebhurvmch3y/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.1-canary.23_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_bab_ghquls7ng4vr2wvebhurvmch3y/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.1-canary.23_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_bab_ghquls7ng4vr2wvebhurvmch3y/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.1-canary.23_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_bab_ghquls7ng4vr2wvebhurvmch3y/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.1-canary.23_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_bab_ghquls7ng4vr2wvebhurvmch3y/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
